import { useCallback, useRef } from "react";
import { useForm } from "@mantine/form";
import { DatePickerInput } from "@mantine/dates";
import { Button, Group, Input, TextInput } from "@mantine/core";
import { Editor } from "@tiptap/react";
import {
  WebUpdateFields,
  NewRequestFormProps
} from "../../types/request.types";
import ContentEditor from "../ContentEditor";
import FormAttachments from "../attachments/FormAttachments";
import FormContacts from "../contacts/FormContacts";

export default function WebUpdateForm(props: NewRequestFormProps) {
  const { onSubmit, tempId } = props;
  const descEditorRef = useRef<Editor>(null);
  const urlsEditorRef = useRef<Editor>(null);
  const form = useForm<WebUpdateFields>({
    mode: 'uncontrolled',
    initialValues: {
      name: '',
      description: '',
      urls: '',
      requested_completion_date: null
    },
    validate: {
      description: val => (
        descEditorRef.current && descEditorRef.current.getText().length > 0 ?
          null : 'Please fill out this field'
      ),
      urls: val => (
        urlsEditorRef.current && urlsEditorRef.current.getText().length > 0 ?
          null : 'Please fill out this field'
      ),
      requested_completion_date: val => (
        val ? null : 'Please fill out this field'
      )
    }
  });

  const onFormSubmit = useCallback((submitVals: WebUpdateFields) => {
    const newRequest = { ...submitVals };
    newRequest.description = descEditorRef.current?.getHTML() || '';
    newRequest.urls = urlsEditorRef.current?.getHTML() || '';
    onSubmit(newRequest);
  }, []);

  return (
    <form onSubmit={form.onSubmit(onFormSubmit)}>
      <Input.Wrapper
        label="Contacts"
        mt="md"
      >
        <FormContacts<WebUpdateFields> form={form} />
      </Input.Wrapper>
      
      <TextInput
        {...form.getInputProps('name')}
        key={form.key('name')}
        label="Project name"
        mt="md"
        required
      />
      
      <ContentEditor<WebUpdateFields>
        formKey="description"
        label="Description"
        required
        form={form} 
        editorRef={descEditorRef}
        mt="md"
      />

      <ContentEditor<WebUpdateFields>
        formKey="urls"
        label="URL(s)"
        required
        form={form} 
        editorRef={urlsEditorRef}
        mt="md"
      />

      <DatePickerInput
        {...form.getInputProps('requested_completion_date')}
        key={form.key('requested_completion_date')}
        label="Requested completion date"
        required
        highlightToday
        mt="md"
      />

      <Input.Wrapper
        label="Attachments"
        mt="md"
      >
        <FormAttachments tempId={tempId} />
      </Input.Wrapper>

      <Group justify="flex-end" mt="md" bg="gray.1" p="sm">
        <Button type="submit">Submit</Button>
      </Group>
    </form>
  );
}
